import { IconButton, Typography } from 'core/common/ui/ui-kit';
import { prepareHtml } from 'core/common/utils/prepareHtml';
import { HeaderStyled, CrossIconStyled } from './styled';

type ModalHeaderProps = {
  title?: string;
  onClose?: () => void;
  className?: string;
};

export const ModalHeader = ({ title, onClose, className, ...props }: ModalHeaderProps) => {
  return (
    <HeaderStyled className={className} {...props}>
      <Typography variant="h4" dangerouslySetInnerHTML={prepareHtml(title)} />
      {onClose && (
        <IconButton onClick={onClose}>
          <CrossIconStyled name="cross" />
        </IconButton>
      )}
    </HeaderStyled>
  );
};
